import type { FaireProductEntity } from "../../entity_types/product";

export const p_zecpjt6hd3: FaireProductEntity = {
  token: "p_zecpjt6hd3",
  type: "product",
  name: "Wildlife of the Southeast",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/acbabcc81403a50ca472572d8d4813bab83e47454cfaf3a25c66883b6cb2bb8e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/79b872b71f311ba6293d1876f71f4e72fdb7acbd771ce67a0be47726bb9b2125.jpeg",
    "https://cdn.faire.com/fastly/9d6f600b0002fcaa99e064de5769922edfb7260436a4894596f1604da6456a5e.jpeg",
    "https://cdn.faire.com/fastly/9f364d408ca9cd14ab4466b44d9641e6c16c2b5ec7864dee20cc756f27d467bb.jpeg"
  ],
  priceDollars: 15,
  description: "From one of the region’s track and sign experts comes a guide to finding and identifying wildlife in the swamps, forests, rivers, meadows, and mountains of the southeastern United States. It’s possible to safely see fascinating wildlife—if you know what to look for and where. Wildlife of the Southeast makes it easier than ever to understand the fascinating creatures you’ll encounter, with illustrated descriptions for more than 125 mammals, birds, reptiles, amphibians, and invertebrates. Covering the diverse habitats from Maryland, south to Florida, west to Louisiana, north to Kentucky and West Virginia, and every state in between, this book is a must-have for nature lovers of all ages and skill levels.",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:50.263Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
